(function() {
    'use strict';

    angular
        .module('cloudApp')
        .controller('CompanyController', CompanyController);


    CompanyController.$inject = [ '$timeout', 'Auth', 'LoginService', 'errorConstants', '$state', '$location', 'Company', 'InviteService', 'AlertService'];

    function CompanyController ($timeout, Auth, LoginService, errorConstants, $state, $location, Company, InviteService, AlertService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        var obj = $location.search();

        if(!(obj.company && obj.invite)) {
            $state.go('home');
        }
        else{
            Company.get({id: obj.company}).$promise.then(function(comp) {
                vm.company = comp;
            }, function(errResponse) {
                vm.error = 'Company not found';
            });

            InviteService.getInvite(obj.invite).then(function(response) {
                var data = response.data;
                vm.invite = data;
                vm.registerAccount.email = vm.invite.email;

            }).catch(function(response) {
                AlertService.error(response);
            });



        }


        function register () {

            var obj = $location.search();

            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey =  'en' ;
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;
                vm.registerAccount.login = vm.registerAccount.email;

                Auth.registerDbhawk(vm.registerAccount, obj.company, obj.invite ).then(function (response) {
                    vm.result = response;
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.LOGIN_ALREADY_USED_TYPE) {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && angular.fromJson(response.data).type === errorConstants.EMAIL_ALREADY_USED_TYPE) {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }

    }
})();
